import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
    EligibilityQuestionModel,
    EligibilityPayloadModel,
} from '../model/eligibility';
import { throwError as observableThrowError } from 'rxjs';
import { catchError } from 'rxjs/operators';
@Injectable()
export class EligibilityQuestionsService {
    public url = environment.backend + environment.uri.eligibilityQuestions;

    constructor(private http: HttpClient) {}

    getEligibilityQuestions(
        eligibilityQuestionsPayload: EligibilityPayloadModel
    ): Observable<any> {
        return this.http.post<any>(this.url, eligibilityQuestionsPayload).pipe(
            catchError((error: Response) => {
                return observableThrowError(error);
            })
        );
    }
}
